import { sizes } from 'styles/sizes';
import { useMedia } from './useMedia';

interface Breakpoint {
	isMobile: boolean;
	isTabletPortrait: boolean;
	isTabletLandscape: boolean;
	isDesktop: boolean;
}

export const useBreakpoint: () => Breakpoint = () => {
	const isMobile = useMedia(`(min-width: ${sizes.mobile}px) and (max-width: ${sizes.tabletPortrait - 1}px)`);
	const isTabletPortrait = useMedia(`(min-width: ${sizes.tabletPortrait}px) and (max-width: ${sizes.tabletLandscape - 1}px)`);
	const isTabletLandscape = useMedia(`(min-width: ${sizes.tabletLandscape}px) and (max-width: ${sizes.desktop - 1}px)`);
	const isDesktop = useMedia(`(min-width: ${sizes.desktop}px`);

	return {
		isMobile,
		isTabletPortrait,
		isTabletLandscape,
		isDesktop,
	};
};
